import cert1 from "../assets/images/certificate1.png";
import cert2 from "../assets/images/certificate2.png";
import cert3 from "../assets/images/certificate3.png";
import cert4 from "../assets/images/certificate4.png";
import cert5 from "../assets/images/certificate5.png";
import cert6 from "../assets/images/certificate6.png";
import cert7 from "../assets/images/certificate7.png";

export const certificatesData = [
  {
    id: 1,
    image: cert1,
    title: "ISO 9001:2015 Certification",
    issuer: "Ranalysis Certification Pvt. Ltd.",
    badge: "Quality Management",
    description: "Certified ISO 9001:2015 Quality Management System for AI and custom software solutions.",
    orientation: "portrait",
    aspectRatio: "0.71",
  },
  {
    id: 2,
    image: cert2,
    title: "ISO/IEC 27001:2022 Certification",
    issuer: "Ranalysis Certification Pvt. Ltd.",
    badge: "Information Security",
    description: "Certified ISO/IEC 27001:2022 Information Security Management System for cloud and AI architectures.",
    orientation: "portrait",
    aspectRatio: "0.71",
  },
  {
    id: 3,
    image: cert3,
    title: "Startup India Recognition",
    issuer: "DPIIT, Ministry of Commerce & Industry",
    badge: "Govt of India Startup",
    description: "Official recognition as a certified AI and machine learning startup by DPIIT.",
    orientation: "landscape",
    aspectRatio: "1.44",
  },
  {
    id: 4,
    image: cert4,
    title: "GST Registration",
    issuer: "Government of India",
    badge: "Tax Compliance",
    description: "Government of India official Goods and Services Tax registration for business operations.",
    orientation: "portrait",
    aspectRatio: "0.74",
  },
  {
    id: 5,
    image: cert5,
    title: "Importer Exporter Code (IEC)",
    issuer: "DGFT, Ministry of Commerce & Industry",
    badge: "Global Commerce",
    description: "Certified Importer Exporter Code issued by DGFT for international commerce and trade.",
    orientation: "portrait",
    aspectRatio: "0.72",
  },
  {
    id: 6,
    image: cert6,
    title: "ISA Membership",
    issuer: "International Society of Automation",
    badge: "Industry Standards",
    description: "Recognized corporate leadership membership with the International Society of Automation.",
    orientation: "landscape",
    aspectRatio: "1.29",
  },
  {
    id: 7,
    image: cert7,
    title: "MSME Udyam Registration",
    issuer: "Ministry of MSME, Govt. of India",
    badge: "Enterprise Registry",
    description: "Official Udyam Registration enterprise certification issued by the Ministry of MSME, India.",
    orientation: "portrait",
    aspectRatio: "0.71",
  },
];

export default certificatesData;

